import clsx from "clsx";

import type { QuoteStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import styles from "./quote.module.css";

type QuoteProps = { blok: QuoteStoryblok };

const alignmentClasses = {
  left: "",
  center: styles.center,
  right: styles.right
};

const Quote = ({ blok }: { blok: QuoteStoryblok }) => {
  const aligmentClass: string | undefined =
    alignmentClasses[blok.align as keyof typeof alignmentClasses];

  return (
    <div
      className={clsx(styles.root, aligmentClass)}
      data-layout="blok"
      data-container="large"
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <div className={styles.wrapper}>
        <div className={styles.tags}>
          <BoldTag blok={blok} />
          <RegularTag blok={blok} />
        </div>
        <Heading blok={blok} />
        <CallToAction blok={blok} />
      </div>
    </div>
  );
};

export default Quote;

const BoldTag = ({ blok }: QuoteProps) =>
  !blok.boldTag ? null : <strong>{blok.boldTag}</strong>;

const RegularTag = ({ blok }: QuoteProps) =>
  !blok.regularTag ? null : <span>{blok.regularTag}</span>;

const Heading = ({ blok }: QuoteProps) =>
  !blok.heading ? null : <h2 className="blok-title">{blok.heading}</h2>;

const CallToAction = ({ blok }: QuoteProps) => {
  const cta = blok.cta?.[0];
  return cta ? (
    <div className={styles.cta}>
      <StoryblokComponent type="button" blok={cta} />
    </div>
  ) : null;
};
